import { apiCall } from "../../../services/api-service.js";

const get = (endpoint, params) => apiCall("get", endpoint, null, { params });
const post = (endpoint, body) => apiCall("post", endpoint, body);
const put = (endpoint, body) => apiCall("put", endpoint, body);
const del = (endpoint, data = null) => apiCall("delete", endpoint, data);

export const getBankListApi = async (params) => {
    try {
        return await get("bank", params);
    } catch (err) {
        console.error("Error fetching banks:", err);
        return { data: { success: false, message: err.message } };
    }
};

export const submitBankApi = async (body) => {
    try {
        return await post("bank", body);
    } catch (err) {
        if (err.response && err.response.data) {
            return err.response;
        } else {
            return { data: { success: false, message: err.message } };
        }
    }
};

export const updateBankApi = async (id, body) => {
    try {
        return await put(`bank/${id}`, body);
    } catch (err) {
        if (err.response && err.response.data) {
            return err.response;
        } else {
            return { data: { success: false, message: err.message } };
        }
    }
};

export const deleteBankApi = async (id) => {
    try {
        return await del(`bank/delete/${id}`);
    } catch (err) {
        if (err.response && err.response.data) {
            return err.response;
        } else {
            return { data: { success: false, message: err.message } };
        }
    }
};

export const getBankByIdApi = async (id) => {
    try {
        return await get(`bank/edit/${id}`);
    } catch (err) {
        if (err.response && err.response.data) {
            return err.response;
        } else {
            return { data: { success: false, message: err.message } };
        }
    }
};

export const getBankSuggestionsApi = async (params) => {
    try {
        return await get("get_bank", params);
    } catch (err) {
        if (err.response && err.response.data) {
            return err.response;
        } else {
            return { data: { success: false, message: err.message } };
        }
    }
};
